document.__SCROLLABLE__ = false

document.addEventListener('touchmove', event => {
  if (document.__SCROLLABLE__) return
  event.preventDefault()
})
